// extracted by mini-css-extract-plugin
export var card_seats_duration_wrapper = "index-module--card_seats_duration_wrapper--f0c58";
export var deco_icon = "index-module--deco_icon--b653e";
export var duration_desc = "index-module--duration_desc--6e54e";
export var duration_part = "index-module--duration_part--c66d6";
export var help_icon = "index-module--help_icon--aa5e2";
export var only_title = "index-module--only_title--87da7";
export var seat_desc = "index-module--seat_desc--8fdcd";
export var seat_part = "index-module--seat_part--e41fc";
export var tooltip = "index-module--tooltip--58eaa";